import React from 'react';
import { ContentTemplate, Progress } from 'web-library';

const LoadingComponent = ({ isOpaque }: { isOpaque?: boolean }) => (
  <ContentTemplate continuous transparent={!isOpaque}>
    <Progress color="secondary" />
  </ContentTemplate>
);

export default LoadingComponent;
